export interface TrialRatingOption {
  value: 1 | 2 | 3;
  text: string;
}

export interface TrialRatingQuestion {
  key: string; // e.g. "1_1"
  label: string;
  options: TrialRatingOption[];
}

export interface TrialRatingPart {
  title: string;
  questions: TrialRatingQuestion[];
}

export const TRIAL_BEHAVIOR_PARTS: TrialRatingPart[] = [
  {
    title: "Part 1: การสอนของครูช่วยให้น้องเข้าใจบทเรียนหรือไม่?",
    questions: [
      {
        key: "1_1",
        label: "1.1 ครูอธิบายเนื้อหาอย่างชัดเจนและเป็นลำดับขั้นตอน",
        options: [
          { value: 3, text: "ครูอธิบายชัดเจนมาก (เข้าใจง่าย ไม่มีความสับสน)" },
          { value: 2, text: "ครูอธิบายปานกลาง (บางส่วนชัดเจน แต่มีจุดที่สับสนเล็กน้อย)" },
          { value: 1, text: "ครูอธิบายไม่ชัดเจน (มีจุดที่น้องไม่เข้าใจหรือสับสน)" },
        ],
      },
      {
        key: "1_2",
        label: "1.2 ครูใช้ตัวอย่างหรือสื่อช่วยสอนที่เหมาะสม",
        options: [
          { value: 3, text: "ใช้ตัวอย่างหรือสื่อที่เชื่อมโยงกับบทเรียนได้ดี" },
          { value: 2, text: "ใช้ตัวอย่างหรือสื่อ แต่บางครั้งไม่เชื่อมโยง" },
          { value: 1, text: "ไม่มีการใช้ตัวอย่างหรือสื่อช่วยสอน" },
        ],
      },
      {
        key: "1_3",
        label: "1.3 น้องสามารถตอบคำถามหรืออธิบายสิ่งที่เรียนได้อย่างมั่นใจ",
        options: [
          { value: 3, text: "ตอบหรืออธิบายได้อย่างมั่นใจ" },
          { value: 2, text: "ตอบหรืออธิบายได้บ้าง แต่ไม่มั่นใจ" },
          { value: 1, text: "ไม่สามารถตอบหรืออธิบายได้" },
        ],
      },
    ],
  },
  {
    title: "Part 2: การสอนของครูช่วยให้น้องชอบบทเรียนหรือไม่?",
    questions: [
      {
        key: "2_1",
        label: "2.1 ครูสร้างบรรยากาศการเรียนที่สนุกและผ่อนคลาย",
        options: [
          { value: 3, text: "บรรยากาศสนุกและผ่อนคลายมาก (น้องดูมีความสุข)" },
          { value: 2, text: "บรรยากาศปานกลาง (น้องสนุกบ้าง แต่มีจุดเงียบ)" },
          { value: 1, text: "บรรยากาศไม่สนุก (น้องดูเบื่อหรือไม่สนใจ)" },
        ],
      },
      {
        key: "2_2",
        label: "2.2 ครูมีการชื่นชมหรือสร้างแรงจูงใจให้น้อง",
        options: [
          { value: 3, text: "มีการชื่นชมและกระตุ้นน้องบ่อยครั้ง" },
          { value: 2, text: "มีการชื่นชมบางครั้ง แต่ไม่สม่ำเสมอ" },
          { value: 1, text: "ไม่มีการชื่นชมหรือกระตุ้น" },
        ],
      },
      {
        key: "2_3",
        label: "2.3 น้องแสดงความสนใจหรือมีส่วนร่วมในการเรียน",
        options: [
          { value: 3, text: "มีส่วนร่วมมาก (ตั้งใจ ฟัง ถาม หรือแสดงความเห็น)" },
          { value: 2, text: "มีส่วนร่วมปานกลาง (ตั้งใจบ้าง แต่เงียบ)" },
          { value: 1, text: "ไม่มีส่วนร่วม (น้องดูไม่สนใจ)" },
        ],
      },
    ],
  },
  {
    title: "Part 3: การสอนของครูช่วยให้น้องอยากเรียนต่อหรือไม่?",
    questions: [
      {
        key: "3_1",
        label: "3.1 ครูมีการกระตุ้นให้น้องตั้งเป้าหมายการเรียนต่อ",
        options: [
          { value: 3, text: "กระตุ้นชัดเจน (เช่น พูดถึงเป้าหมายในอนาคต)" },
          { value: 2, text: "กระตุ้นบางส่วน แต่ไม่ชัดเจน" },
          { value: 1, text: "ไม่มีการกระตุ้น" },
        ],
      },
      {
        key: "3_2",
        label: "3.2 น้องแสดงความกระตือรือร้นที่จะเรียนเนื้อหาต่อไป",
        options: [
          { value: 3, text: "แสดงความกระตือรือร้นหรือพูดถึงความอยากเรียนต่อ" },
          { value: 2, text: "เฉยๆ แต่ไม่ได้ปฏิเสธ" },
          { value: 1, text: "แสดงท่าทีไม่อยากเรียนต่อ" },
        ],
      },
      {
        key: "3_3",
        label: "3.3 น้องแสดงความมั่นใจที่จะกลับมาเรียนในครั้งหน้า",
        options: [
          { value: 3, text: "แสดงความมั่นใจและพูดถึงการเรียนครั้งหน้า" },
          { value: 2, text: "ยังไม่ชัดเจนว่าน้องมั่นใจหรือไม่" },
          { value: 1, text: "น้องดูไม่มั่นใจ" },
        ],
      },
    ],
  },
  {
    title: "Part 4: การสอนช่วยให้น้องทบทวนและยืนยันความเข้าใจได้หรือไม่?",
    questions: [
      {
        key: "4_1",
        label: "4.1 ครูเปิดโอกาสให้น้องอธิบายสิ่งที่เข้าใจหรือยกตัวอย่างกลับมา",
        options: [
          { value: 3, text: "เปิดโอกาสให้น้องอธิบายและแสดงความเข้าใจชัดเจน" },
          { value: 2, text: "เปิดโอกาสบางส่วน แต่น้องยังไม่แสดงความเข้าใจได้เต็มที่" },
          { value: 1, text: "ไม่ได้เปิดโอกาสให้น้องอธิบาย" },
        ],
      },
      {
        key: "4_2",
        label: "4.2 ครูตอบคำถามและยืนยันความถูกต้องให้กับน้องเมื่อมีข้อสงสัย",
        options: [
          { value: 3, text: "ตอบคำถามและยืนยันความถูกต้องอย่างชัดเจน" },
          { value: 2, text: "ตอบคำถามบางส่วน แต่ยังขาดความชัดเจน" },
          { value: 1, text: "ไม่ได้ตอบคำถามหรือละเลยข้อสงสัย" },
        ],
      },
      {
        key: "4_3",
        label: "4.3 น้องสามารถพูดทบทวนหรือเล่าเรื่องที่เกี่ยวข้องได้อย่างมั่นใจ",
        options: [
          { value: 3, text: "พูดหรือเล่าเรื่องได้อย่างมั่นใจ" },
          { value: 2, text: "พูดหรือเล่าได้บ้าง แต่ยังไม่มั่นใจ" },
          { value: 1, text: "ไม่สามารถพูดหรือเล่าได้" },
        ],
      },
    ],
  },
];

export const TRIAL_BEHAVIOR_QUESTION_COUNT = TRIAL_BEHAVIOR_PARTS.reduce(
  (n, p) => n + p.questions.length,
  0,
);
export const TRIAL_BEHAVIOR_MAX_SCORE = TRIAL_BEHAVIOR_QUESTION_COUNT * 3;